import { Trans } from '@lingui/react/macro';
import { type FacilityTransferRoundPublicRecord, FacilityTransferDirection } from '@navio/nsdk';
import { useFacilityTimeZone } from './facilityTimeZone';
import { mergeRoundsByTime } from './pickupRounds';

interface Props {
  facilityName: string;
  pickupDay: string;
  itemCount: number;
  rounds: FacilityTransferRoundPublicRecord[];
}

export const PickupIntro = ({ facilityName, pickupDay, itemCount, rounds }: Props) => {
  const timeZone = useFacilityTimeZone();
  const pickups = mergeRoundsByTime(rounds, FacilityTransferDirection.OUTGOING, timeZone);
  const firstPickupTime = pickups[0]?.time ?? null;

  return (
    <p className='text-sm'>
      {firstPickupTime == null ? (
        <Trans>
          {itemCount} wheel sets will be picked up from {facilityName} on {pickupDay}. The pickup time is not set yet.
        </Trans>
      ) : pickups.length > 1 ? (
        // The pickup banner below lists every pickup time.
        <Trans>
          {itemCount} wheel sets will be picked up from {facilityName} on {pickupDay}.
        </Trans>
      ) : (
        <Trans>
          {itemCount} wheel sets will be picked up from {facilityName} on {pickupDay}. The pickup is estimated from{' '}
          {firstPickupTime}.
        </Trans>
      )}{' '}
      <Trans>Mark each wheel set as ready, or report an issue with a short note.</Trans>
    </p>
  );
};
